var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.forgeStatus === 'success')?_c('div',{staticClass:"d-flex flex-grow-1 flex-scroll-height"},[_c('forge-viewer',{ref:"forge-viewer",staticClass:"flex-grow-1",staticStyle:{"height":"auto"},attrs:{"client":_vm.forgeData.CFFA_FORGE_CLIENT.records[0],"custom-extensions":['RfisExtension'],"extension-options":[],"extensions":[
      'Autodesk.DocumentBrowser',
      'Autodesk.Geolocation',
      'Autodesk.VisualClusters',
    ],"models":_vm.forgeData.CFFA_FORGE_MODELS.records}}),_c('ant-view-loading',{attrs:{"loading":_vm.$wait.is(`tasks.get.*`)}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }